var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      ref: "content",
      class: { "cell-truncate": _vm.truncate },
      style: _vm.truncate ? { display: "block", width: _vm.cellWidth } : {},
    },
    [
      _vm._v("\n    " + _vm._s(_vm.text)),
      _vm.isTooltipEnabled
        ? _c(
            "b-tooltip",
            {
              attrs: {
                animation: false,
                delay: _vm.tooltipDelayConfig,
                placement: "left",
                target: () => _vm.$refs.content,
                triggers: "hover",
              },
            },
            [
              _c("span", {
                class: _vm.small ? "small" : "",
                domProps: { innerHTML: _vm._s(_vm.tooltip) },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }